import React from 'react';
import update from 'immutability-helper';
import Select from 'react-select';
import enums from '../../common/utils/enums';
import I18n from '../../../config/i18n';
import { getFinalValueForValidation } from '../../common/validations';
import { reactSelectTheme } from '../../common/utils/uiHelper';
import TextField from '../common/TextField';

export default class Bandwidth extends React.Component {
  constructor(props) {
    super(props);

    this.bandwidthFieldRef = React.createRef();
    this.bandwidthUnitRef = React.createRef();
    this.changeBandwidthUnit = this.changeBandwidthUnit.bind(this);
    this.triggerChange = this.triggerChange.bind(this);
  }

  changeBandwidthUnit(newValue) {
    let { bandwidth, onChange } = this.props;

    let newBandwidth = update(bandwidth, { unit: { $set: newValue.value } });
    onChange(newBandwidth);
  }

  triggerChange(value) {
    let { bandwidth, onChange } = this.props;

    let _value = getFinalValueForValidation(value);

    let newBandwidth = update(bandwidth, { value: { $set: _value } });
    onChange(newBandwidth);
  }

  renderBandwidth() {
    let { bandwidth, errors } = this.props;
    let options = [
      {
        value: enums.BandwidthUnits.KILO_BITS_PER_SECOND,
        label: enums.BandwidthUnits.KILO_BITS_PER_SECOND,
      },
      {
        value: enums.BandwidthUnits.MEGA_BITS_PER_SECOND,
        label: enums.BandwidthUnits.MEGA_BITS_PER_SECOND,
      },
      {
        value: enums.BandwidthUnits.GIGA_BITS_PER_SECOND,
        label: enums.BandwidthUnits.GIGA_BITS_PER_SECOND,
      },
      {
        value: enums.BandwidthUnits.TERA_BITS_PER_SECOND,
        label: enums.BandwidthUnits.TERA_BITS_PER_SECOND,
      },
    ];

    return (
      <div className="clearfix">
        <div className="col col-1 pr1">
          <TextField
            autofocus
            ref={this.bandwidthFieldRef}
            fullWidth
            type="tel"
            hintText="Value"
            value={bandwidth.value}
            errorText={
              errors &&
              (errors.self || errors.value) &&
              I18n.t('enterAValidValue')
            }
            handleChange={this.triggerChange}
          />
        </div>
        <div className="col col-1 pl1">
          <Select
            ref={this.bandwidthUnitRef}
            clearable={false}
            value={
              bandwidth.unit && { label: bandwidth.unit, value: bandwidth.unit }
            }
            options={options}
            onChange={this.changeBandwidthUnit}
            placeholder={I18n.t('unit')}
            theme={reactSelectTheme()}
          />
          <div className="ui-error">
            {errors && errors.unit && I18n.t('enterAValidValue')}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="pt3">
        <div className="h4">{I18n.t('allocatedBandwidth')}</div>
        <div className="h5 mt1">{I18n.t('bandwidthMessage')}</div>
        <div>
          <div className="clearfix">
            <div className="col col-3 bold h5 mt2">{I18n.t('bandwidth')}</div>
          </div>
          {this.renderBandwidth()}
        </div>
      </div>
    );
  }
}
